import React from "react";

const TarifCell = ({tarifChoice, healthGuarantees, optional}) => {

    let label1, label2, price1, price2 = "";

    if(tarifChoice === "tarificationChoice1"){
        label1 = "Isolé";
        price1 = optional ? parseFloat(healthGuarantees?.healthTariff.isolatedForIsoFamOptional).toFixed(2) : parseFloat(healthGuarantees?.healthTariff.isolatedForIsoFam).toFixed(2);
        label2 = "Famille";
        price2 = optional ? parseFloat(healthGuarantees?.healthTariff.familyForIsoFamOptional).toFixed(2) : parseFloat(healthGuarantees?.healthTariff.familyForIsoFam).toFixed(2);
    } else if(tarifChoice === "tarificationChoice2") {
        label1 = "Uniforme";
        price1 = optional ? parseFloat(healthGuarantees?.healthTariff.fixedPriceOptional).toFixed(2) : parseFloat(healthGuarantees?.healthTariff.fixedPrice).toFixed(2);
    }else if(tarifChoice === "tarificationChoice3") {
        label1 = "Adulte";
        price1 = optional ? parseFloat(healthGuarantees?.healthTariff.adultOptional).toFixed(2) : parseFloat(healthGuarantees?.healthTariff.adult).toFixed(2);
        label2 = "Enfant";
        price2 = optional ? parseFloat(healthGuarantees?.healthTariff.childOptional).toFixed(2) : parseFloat(healthGuarantees?.healthTariff.child).toFixed(2);
    }

    return (
        healthGuarantees && price1 !== "NaN" && price2 !== "NaN" ?
            <div
                className={`tw-flex tw-h-[80px] tw-p-3 tw-flex-col tw-justify-center tw-items-center
                        ${tarifChoice != "tarificationChoice2" && "tw-gap-2"} tw-self-stretch tw-border-b tw-border-solid tw-border-mutelios-blue-light`}>
                <div className="tw-flex tw-justify-between tw-items-center tw-self-stretch">
                    <span className="tw-text-body tw-text-mutelios-txt-color">{label1}</span>
                    <span
                        className="tw-text-body-bold tw-text-mutelios-txt-color">{price1} €</span>

                </div>
                {label2 &&
                    <div className="tw-flex tw-justify-between tw-items-center tw-self-stretch">
                        <span className="tw-text-body tw-text-mutelios-txt-color">{label2}</span>
                        <span className="tw-text-body-bold tw-text-mutelios-txt-color">{price2} €</span>
                    </div>
                }
            </div>
            : <div
                className="tw-flex tw-h-[80px] tw-p-3 tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-self-stretch tw-border-b tw-border-solid tw-border-mutelios-blue-light">
                <span className="tw-text-body-lead-bold tw-text-mutelios-txt-color">-</span>
            </div>
    );
}

export default TarifCell;
